import React from "react";
import PropTypes from "prop-types";
import { Select3, Form } from "@weezevent/nacre";
import {
	CONDITION_TYPES,
	TEXTFIELD_FIELD_TYPE
} from "../../../../models/forms-with-entry-usage";

const ConditionSelector = ({ fieldType, selectedCondition, onChange, t }) => {
	const conditionOptions = React.useMemo(() => {
		if (!fieldType) return [];

		const conditions =
			CONDITION_TYPES[fieldType] || CONDITION_TYPES[TEXTFIELD_FIELD_TYPE];

		return conditions.map(conditionValue => ({
			value: conditionValue,
			text: t(
				`access.attendees.attendeesList.filters.formFields.conditions.${conditionValue}`
			)
		}));
	}, [fieldType, t]);

	if (conditionOptions.length === 0) return null;

	return (
		<Form.Field>
			<Form.Label>
				{t(
					"access.attendees.attendeesList.filters.formFields.condition"
				)}
			</Form.Label>
			<Select3
				options={conditionOptions}
				value={selectedCondition || ""}
				onChange={onChange}
				placeholder={t(
					"access.attendees.attendeesList.filters.formFields.selectCondition"
				)}
			/>
		</Form.Field>
	);
};

ConditionSelector.propTypes = {
	fieldType: PropTypes.string,
	selectedCondition: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	t: PropTypes.func.isRequired
};

export default ConditionSelector;
